<div [ngClass]="loading() ? 'visually-hidden' : ''">
  <app-auth-header></app-auth-header>
  <div class="flex justify-center items-center min-h-[400px]">
    <div class="text-center max-w-md mx-auto p-8">
      <!-- Error Icon and Title -->
      <div class="mb-6">
        <div class="w-20 h-20 bg-jamaica-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg class="w-10 h-10 text-jamaica-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
          </svg>
        </div>
        <h1 class="text-3xl font-bold text-jamaica-red-600 dark:text-jamaica-red-400 mb-2">
          Oops! Something went wrong
        </h1>
      </div>

      <!-- Error Message -->
      <div class="mb-8">
        <div class="bg-jamaica-red-50 dark:bg-jamaica-red-900/20 border border-jamaica-red-200 dark:border-jamaica-red-800 rounded-lg p-4 mb-4" *ngIf="errorMessage">
          <p class="text-jamaica-red-700 dark:text-jamaica-red-300 font-medium">{{ errorMessage }}</p>
        </div>
        <p class="text-gray-600 dark:text-gray-400">
          We're sorry for the inconvenience. Please try again or return to the home page.
        </p>
      </div>

      <!-- Action Button -->
      <button
        type="button"
        (click)="goHome()"
        class="inline-flex items-center px-6 py-3 text-lg font-medium text-jamaica-black-900 bg-jamaica-gold-400 border border-transparent rounded-lg hover:bg-jamaica-gold-500 focus:ring-4 focus:ring-jamaica-gold-300 disabled:opacity-50 disabled:cursor-not-allowed dark:bg-jamaica-gold-500 dark:hover:bg-jamaica-gold-600 dark:focus:ring-jamaica-gold-400 transition-colors duration-200">
        <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
        </svg>
        Return Home
      </button>
    </div>
  </div>
  <app-auth-footer></app-auth-footer>
</div>
